import { useTranslation } from 'react-i18next';
import type { AuditLogQuery } from '@/api/audit/auditApi.types';
import { ActivityEntryRow } from '@/components/common/ActivityLog/ActivityEntryRow';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { useAuditLogsQuery } from '@/hooks/useAuditLogsQuery';

const RECENT_ACTIVITY_LIMIT = 6;

const RECENT_ACTIVITY_QUERY: AuditLogQuery = {
  page: 1,
  pageSize: RECENT_ACTIVITY_LIMIT,
  search: '',
  category: 'change',
  clientId: null,
  occurredFrom: null,
  occurredUntil: null,
};

export function RecentActivityPanel() {
  const { t } = useTranslation('admin');
  const auditLogsQuery = useAuditLogsQuery(RECENT_ACTIVITY_QUERY);
  const entries =
    auditLogsQuery.data === undefined
      ? []
      : auditLogsQuery.data.items.slice(0, RECENT_ACTIVITY_LIMIT);

  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="Activity" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('dashboard.recentActivity.title')}</h2>
      </div>
      {auditLogsQuery.isLoading === true ? (
        <div className="py-6 flex justify-center">
          <LoadingSpinner className="w-6 h-6" />
        </div>
      ) : auditLogsQuery.isError === true ? (
        <QueryErrorState
          onRetry={function retry() {
            auditLogsQuery.refetch();
          }}
        />
      ) : entries.length === 0 ? (
        <p className="text-[13px] text-zoomuted py-1">{t('dashboard.recentActivity.empty')}</p>
      ) : (
        <ul className="divide-y divide-zooborder">
          {entries.map(function renderEntry(entry) {
            return <ActivityEntryRow key={entry.id} entry={entry} showWorkspace compact />;
          })}
        </ul>
      )}
    </Card>
  );
}
